module.exports = __webpack_public_path__ + "img/27.be1460cb.jpg";